<template>
    <div class="group-page-chat">
        <div class="group-page-chat__info-panel">
            <chats-list-new-messages-counter
                    :total-messages-count="chat.messages_count"
                    :unread-messages-count="chat.unread_count"
            ></chats-list-new-messages-counter>
            <i
                    v-if="chat.following"
                    class="fal fa-minus-square color-footer-red group-page-chat__counter-icon group-page-chat__counter-icon_delete pointer"
                    @click="leave"
                    @keydown.enter="leave"
                    v-tooltip="'Leave Chat'"
            ></i>
            <i
                    v-else
                    class="fal fa-plus-square color-grass-green-dark group-page-chat__counter-icon group-page-chat__counter-icon_delete pointer"
                    @click="follow"
                    @keydown.enter="follow"
                    v-tooltip="'Follow Chat'"
            ></i>
            <span class="group-page-chat__time-label">{{ lastMessageTime }}</span>
        </div>
        <div class="group-page-chat__chat-name">
            <a :href="chat.link|backHrefQuery" v-if="chat.link">{{ chat.name|cutName(100) }} <span
                    class="color-tag-gray" v-if="!chat.approved">(Not Approved)</span></a>
        </div>
        <div class="group-page-chat__chat-info">
            <div class="margin-15-top">
                <span>Created by:</span>
                <strong>
                    <simple-link :target="chat.created_by"></simple-link>
                </strong>
            </div>
            <div>
                <span>Created at:</span> <strong>{{ chat.created_at | gbdate }}</strong>
            </div>
        </div>
    </div>
</template>

<script>
    import ChatsListNewMessagesCounter from "../chats/chats_in_list/counters/ChatsListNewMessagesCounter";
    import moment from "moment";

    export default {
        name: "GroupPageChatsChat",
        components: {ChatsListNewMessagesCounter},
        props: {
            chat: Object,
        },
        computed: {
            lastMessageTime() {
                if (this.chat?.last_post_time) {
                    const postTime = moment(this.chat.last_post_time);
                    const isCurrentDate = postTime.isSame(new Date(), "day");
                    const isCurrentYear = postTime.isSame(new Date(), "year");
                    if (isCurrentDate) {
                        return postTime.format("h:mm");
                    } else {
                        if (isCurrentYear) {
                            return postTime.format("MMM Do");
                        } else {
                            return postTime.format("MMM Do YY");
                        }
                    }
                }
            },
        },
        methods: {
            leave() {
                this.$emit('leaveChat');
            },
            follow() {
                this.$emit('followChat');
            }
        }
    };
</script>

<style scoped lang="scss">
  @import "../styles/const";
  @import "../styles/mixins";

  .group-page-chat {
    @include wide_item_container;

    margin-top: 15px;
    font-size: 0;

    &__info-panel {
      margin: 10px 15px 0 15px;
      font-size: 21px;
      color: $tag-gray-dark;
    }

    &__counter-icon {
      vertical-align: top;

      &_delete {
        float: right;
        font-size: 23px;
        display: inline-block;
        line-height: 30px;
      }
    }

    &__time-label {
      font-size: 11px;
      float: right;
      color: $tag-gray;
      display: inline-block;
      margin-right: 10px;
      line-height: 19px;
    }

    &__chat-name {
      padding: 0 15px;
      font-size: 19px;
      @media (min-width: 501px) {
        font-size: 21px;
      }
    }

    &__chat-info {
      padding: 0 15px;
      font-size: $default-font-size;
    }
  }
</style>